import { colorsPalettes } from "@similarweb/styles";
import styled, { css } from "styled-components";
import { MAX_NUMBER_TO_CUT_POSITION } from "./constants";
import { ItemIcon } from "@similarweb/ui-components";

export const AxisLineWrapper = styled.div`
    position: relative;
    width: 100%;
    display: flex;
    align-items: center;
`;

export const AxisDot = styled.span<{
    isPrimaryEntity?: boolean;
    position: number;
    alwaysDisplayIcons?: boolean;
}>`
    position: absolute;

    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;

    width: 18px;
    height: 18px;
    z-index: 1;

    border-radius: 6px;
    background: ${colorsPalettes.carbon[0]};

    .ItemIcon {
        width: 18px;
        height: 18px;
        overflow: hidden;

        img {
            transition: opacity 0.5s;
            opacity: ${({ isPrimaryEntity, alwaysDisplayIcons }) =>
                isPrimaryEntity || alwaysDisplayIcons ? "1" : "0"};

            @media print {
                opacity: 1;
            }
        }
    }

    left: ${({ position }) => (position > MAX_NUMBER_TO_CUT_POSITION ? `calc(${position}% - 16px)` : `${position}%`)};

    ${({ isPrimaryEntity }) => css`
        ${isPrimaryEntity &&
        `   z-index: 2;
            height: 20px;
            width: 20px;
            border: 2px solid ${colorsPalettes.blue[400]};
        `}
    `}
`;

export const RankingAxisWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 100%;
    width: 85%;
    padding-left: 24px;

    &:hover {
        ${AxisDot} {
            & img {
                opacity: 1;
            }
        }
    }
`;

export const StyledItemIcon = styled(ItemIcon)`
    border-color: ${colorsPalettes.carbon[100]};
`;
